import { Button } from "@progress/kendo-react-buttons";
import { AiOutlineFile } from "react-icons/ai";
import { AiOutlineFileText } from "react-icons/ai";

const DocumentIconCounter = ({
	count = 0,
	onClick,
	color = "#3B82F6",
	size = 26
}) => {

	if (count <= 0) return null;

	return (
		<div className="d-flex justify-content-center align-items-center">
			<span className="position-relative d-inline-flex align-items-center justify-content-center">

				<Button className="border-0 bg-transparent p-0" onClick={onClick} >
					{count === 1
						? <AiOutlineFileText color={color} size={size} />
						: <AiOutlineFile color={color} size={size} />
					}
				</Button>

				{count > 1 && (
					<span
						className="position-absolute fw-semibold"
						style={{
							top: "60%",
							left: "50%",
							transform: "translate(-50%, -50%)",
							fontSize: "0.7rem",
							color: color,
							pointerEvents: "none",
						}}
					>
						{count}
					</span>
				)}
			</span>
		</div>
	);
};

export default DocumentIconCounter;
